import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-staking-modal',
  standalone: true,
  templateUrl: './staking-modal.component.html'
})
export class StakingModalComponent {
  public state = inject(AppStateService);
}
